import axiosConfig from './axiosConfig';

// Get categories for POS
export const getCategories = async (search = '') => {
  try {
    const response = await axiosConfig.get(`/products/category/list/`, {
      params: { search }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get brands/subcategories for a specific category
export const getBrandsByCategory = async (categoryId) => {
  try {
    const response = await axiosConfig.get(`/products/brand/list/`, {
      params: { category_id: categoryId }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get products by category and brand
export const getProducts = async (categoryId, brandId = null, search = '', type = null, page = 1) => {
  try {
    const params = { 
      category_id: categoryId,
      search: search || '', // Always include search parameter, even if empty
      page,
      page_size: 50
    };
    if (brandId) params.brand_id = brandId;
    if (type) params.type = type;
    
    const response = await axiosConfig.get(`/products/list/`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Search products by barcode or name with optional filters
export const searchProducts = async (query, categoryId = null, brandId = null, device = null, page = 1) => {
  try {
    const params = { 
      search: query || '', // Always include search parameter, even if empty
      brand_id: brandId || '',
      category_id: categoryId || '',
      device: device || '',
      page,
      page_size: 50
    };
    
    const response = await axiosConfig.get(`/products/list/`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get all products with optional filters
export const getAllProducts = async (search = '', brandId = null, categoryId = null, device = null, page = 1) => {
  try {
    const params = { 
      search: search || '', // Always include search parameter, even if empty
      brand_id: brandId || '',
      category_id: categoryId || '',
      device: device || '',
      page,
      page_size: 50
    };
    
    const response = await axiosConfig.get(`/products/list/`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create cart/sale
export const createCart = async (cartData) => {
  try {
    const response = await axiosConfig.post(`/cart/create/`, cartData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
